var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSearch = function SvgSearch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    stroke: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    stroke: "none",
    d: "M10.8 0c5.965 0 10.8 4.835 10.8 10.8 0 2.505-.853 4.811-2.284 6.643l-.076.096 4.409 4.413a1.2 1.2 0 0 1 .013 1.683l-.014.014a1.2 1.2 0 0 1-1.697 0l-4.408-4.413-.1.08a10.75 10.75 0 0 1-6.464 2.283l-.179.001C4.835 21.6 0 16.765 0 10.8S4.835 0 10.8 0m0 2.4a8.4 8.4 0 1 0 0 16.8 8.4 8.4 0 0 0 0-16.8m0 1.2a7.2 7.2 0 0 1 7.2 7.2 1.2 1.2 0 1 1-2.4 0A4.8 4.8 0 0 0 10.8 6a1.2 1.2 0 1 1 0-2.4"
  })));
};
export default SvgSearch;